module.exports = function (f) {
  var html = "".concat(f.returnFactionSheet(f.faction));
  return html;
};